
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Műszerfal létrehozása',
	'dashboard': 'Műszerfal',
	'dashboardTemplate': 'Műszerfal sablon',
	'createAV': 'Létrehozás',
	'createAvEditNameLabel': '1. Nézet elnevezése',
	'createAvSelectTemplateLabel': '2. Sablon kiválasztása',
	'tabLayoutLabel': 'Lapokra osztott sablon',
	'infographicsLayoutLabel': 'Infografikai sablon',
	'singlePageLayoutLabel': 'Egyoldalas sablon',
	'customLayoutLabel': 'Egyéni sablon',
	'freeformTemplate': 'Szabad formátum',
	'freeformTemplateDesc': 'A szabad formátumú elrendezés megjelenítései pontosan úgy jelennek meg, ahogyan a méretben méretezi és elhelyezi őket, a képernyő méretétől függetlenül. Az egyéb elrendezésekben a megjelenítések mérete és helyzete a képernyő méretéhez igazodik.',
	'NoTemplate': 'Szabad formátum',
	'Template1': 'Üres',
	'Template2': 'Cím 1 x 2',
	'Template3': '2/1',
	'Template4': '4/1',
	'Template5': 'Lábléc 1 x 2',
	'Template6': '1/1 mellett 3',
	'Template7': '3/1 mellett 4',
	'Template8': '2/3 x 2',
	'Template9': '2 x 2',
	'Template10': '2 x 2/1 mellett 1 x 2',
	'Template11': '3 x 1/1 x 2',
	'Template12': '1 x 2 mellett 2/1',
	'Template13': '1 x 4 mellett 1 x 2 mellett 1',
	'Template22': '1/ 2 x 2',
	'Template14': '1 mellett 1',
	'Template15': '1/1 mellett 1',
	'Template16': '1 mellett 1/1',
	'Template17': '1/1 mellett 1/1',
	'Template18': '1/1 mellett 1',
	'Template19': '1/2 mellett 1',
	'Template20': '1/2 x 1',
	'Template21': '1/1 / 2 x 1',
	'Template23': 'Üres és lerakási zóna',
	'Infographics1': 'Üres',
	'Infographics2': '4 sor',
	'Infographics3': '4 sor fejléccel',
	'Infographics4': '2 x 4',
	'Infographics5': 'Nagy felső kijelző, 2 x 2',
	'Infographics6': '2 x 4 függőleges hézaggal',
	'Infographics7': '2 x 4, lépcsőzetes',
	'Infographics8': 'Teniszpálya',
	'Infographics9': '3 x 4',
	'Infographics10': '4 x 8',
	'createAvDashboardLabel': 'Elrendezés',
	'dashboard_template_save_success': 'A rendszer mentette a műszerfalsablont.',
	'dashboard_template_prefix': 'Sablon: "%{name}"',
	'dashboard_template_filters_removed': 'A vásznon lévő szűrők eltávolításra kerültek.',
	'createAvTabLabel': 'Többlapos',
	'createAvInfographicsLabel': 'Infografika',
	'createAvSinglepageLabel': 'Egyetlen oldal',
	'createAvCustomLabel': 'Egyéni',
	'loadMoreLabel': 'Továbbiak betöltése...',
	'backLabel': 'Vissza',
	'addSourceLabel': 'Forrás hozzáadása',
	'pinLabel': 'Rögzítés',
	'errorLoadingDataSetMetaData': 'Hiba történt a metaadatok olvasása során',
	'errorLoadingDataSets': 'Hiba történt az adathalmazok listájának betöltése során',
	'errorLoadingDataSet': 'A(z) "%{datasetName}" adathalmazhoz tartozó metaadatok nem töltődtek be. Forduljon az adminisztrátorhoz a részletekért.',
	'okButton': 'OK',
	'createButton': 'Létrehozás',
	'cancelButton': 'Mégse',
	'copyButton': 'Másolás',
	'selectTemplateLabel': 'Sablon kiválasztása',
	'createBoardTitle': 'Műszerfal létrehozása',
	'createBoardSubtitle': 'Sablon kiválasztása a műszerfalhoz',
	'noSourcesSelectedLabel': 'Nincs kiválasztott forrás',
	'find_label': 'Keresés',
	'noDashboardFound': 'A műszerfal nem kérhető le. Már nem létezik, vagy nem rendelkezik a megfelelő jogosultságokkal a megtekintéséhez.',
	'errorLabel': 'Hiba',
	'defaultName': 'Új műszerfal',
	'noDashboardCapability': 'Nem jogosult a Műszerfal alkalmazás futtatására',
	'noDashboardPermission': 'Nincs megfelelő jogosultsága a műszerfal megtekintéséhez',
	'sourceNotFound': 'A megjelenítés nem tölthető be, mert a hozzá tartozó "%{sourceName}" forrás nem érhető el',
	'cmDuplicateName': 'Már van ilyen nevű elem. Adjon meg másik nevet',
	'cmEmptySelection': 'A műszerfal törölve lett. Próbálja meg új műszerfalként menteni.',
	'propTheme': 'Vizuális téma',
	'legacyThemeLabel': 'Örökölt',
	'carbonGrey10Label': 'Carbon X Light',
	'carbonGrey100Label': 'Carbon X Dark',
	'titleTextLabel': 'Cím',
	'titleSmallTextLabel': 'Kis cím',
	'subtitleTextLabel': 'Alcím',
	'bodyTextLabel': 'Törzs',
	'bodySmallTextLabel': 'Kis törzs',
	'captionTextLabel': 'Felirat',
	'quoteTextLabel': 'Idézet',
	'quoteSmallTextLabel': 'Kis idézet',
	'responsiveTextLabel': 'Automatikus méretezés',
	'mediaWidgetLabel': 'Adathordozó',
	'webpageWidgetLabel': 'Weboldal',
	'imageWidgetLabel': 'Kép',
	'textWidgetLabel': 'Szöveg',
	'notebookWidgetLabel': 'Munkafüzet',
	'multipurposeWidgetLabel': 'Többcélú',
	'textPlaceHolder': 'Kattintson ide a szöveg szerkesztéséhez',
	'titlePlaceHolder': 'Kattintson ide a cím szerkesztéséhez',
	'toggleEditModeLabel': 'Váltás Szerkesztés módra',
	'togglePreviewModeLabel': 'Váltás Előnézet módra',
	'editDashboardCoachMarkTitle': 'Műszerfal szerkesztése',
	'editDashboardCoachMarkContents': 'Kattintson a Ceruza ikonra a műszerfal szerkesztéséhez.',
	'addDataCoachMarkTitle': 'Adatok hozzáadása',
	'addDataDashboardCoachMarkContents': 'Húzzon át adatokat az adatpanelről a műszerfalra.',
	'pageSelectWarning': 'Jelöljön ki egy lapot.',
	'screenshot_label': 'Műszerfal %{title}',
	'screenshot_label_tab': 'A(z) %{title} műszerfal %{tabName} lapja',
	'dataAssetPropertiesLabel': 'Megjelenítési tulajdonságok',
	'modelFilter': 'Szűrő',
	'invertSelectionToolTip': 'Szűrőkijelölések megfordítása',
	'clearFilterValueToolTip': 'Szűrőértékek törlése',
	'invertFilterSelection': 'Megfordítás',
	'clearTextFilterValue': 'Törlés',
	'filterConditionLabel': 'Szűrési feltétel',
	'applyFilter': 'Szűrő alkalmazása',
	'itemCountText': '%{itemCount} elem van kijelölve',
	'itemExcludeCountText': '%{itemCount} elem van kizárva',
	'moreMembers': 'Részletes megjelenítés...',
	'searchHierarchyMembers': 'Tagok megkeresése kereséssel...',
	'propHideEmpty': 'Üres elrejtése',
	'propColorOrder': 'Színsorrend',
	'propElementColor': 'Megjelenítési elem színe',
	'propLineColor': 'Vonalszín',
	'propLineAndSymbolColor': 'Vonal és szimbólum színe',
	'propColumnColor': 'Oszlop színe',
	'propBarColor': 'Sáv színe',
	'propWordColor': 'Szó színe',
	'propAreaColor': 'Terület színe',
	'propRadialbarColor': 'Radiális sáv színe',
	'propColorPalettes': 'Színpaletták',
	'propDashboardColorPalette': 'Aktuális műszerfal paletta',
	'propNewDashboardPaletteLabel': 'Egyéni műszerfal paletta létrehozása',
	'propDashboardChangePaletteLink': 'Műszerfal paletta módosítása',
	'propHideLeafNode': 'Főcímkék elrejtése',
	'propOpacity': 'Átlátszatlanság',
	'propOpacityDescription': 'Az átlátszatlanság növelése vagy csökkentése. Adjon meg egy 0 és 100 közötti értéket',
	'addATab': 'Új lap hozzáadása',
	'propFredIsRed': 'Színkonzisztencia',
	'areaChartCaption': 'Terület',
	'areaChartDataSlot_categoriesLabel': 'Tengelyfelirat',
	'areaChartDataSlot_valuesLabel': 'Érték',
	'areaChartProp_colorPaletteLabel': 'Színpaletták',
	'areaChartProp_lineColorLabel': 'Terület színe',
	'areaChartProp_interpolationLabel': 'Simított vonalak',
	'areaChartProp_interpolationDescription': 'Az adatpontokat összekötő vonalak íveltek.',
	'areaChartProp_hideGridLinesLabel': 'Rácsvonalak elrejtése',
	'areaChartProp_hideGridLinesDescription': 'Rácsvonalak elrejtése',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'areaChartProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'areaChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'areaChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'areaChartProp_suppressZerosLabel': 'Üres elrejtése',
	'areaChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'barChartCaption': 'Sáv',
	'barChartDataSlot_categoriesLabel': 'Tengelyfelirat',
	'barChartDataSlot_valuesLabel': 'Érték',
	'barChartProp_colorPaletteLabel': 'Színpaletták',
	'barChartProp_elementColorLabel': 'Sáv színe',
	'barChartProp_hideGridLinesLabel': 'Rácsvonalak elrejtése',
	'barChartProp_hideGridLinesDescription': 'Rácsvonalak elrejtése',
	'barChartProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'barChartProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'barChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'barChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'barChartProp_suppressZerosLabel': 'Üres elrejtése',
	'barChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'columnChartCaption': 'Oszlop',
	'columnChartDataSlot_categoriesLabel': 'Tengelyfelirat',
	'columnChartDataSlot_valuesLabel': 'Érték',
	'columnChartProp_colorPaletteLabel': 'Színpaletták',
	'columnChartProp_elementColorLabel': 'Oszlop színe',
	'columnChartProp_hideGridLinesLabel': 'Rácsvonalak elrejtése',
	'columnChartProp_hideGridLinesDescription': 'Rácsvonalak elrejtése',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'columnChartProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'columnChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'columnChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'columnChartProp_suppressZerosLabel': 'Üres elrejtése',
	'columnChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'bubbleChartCaption': 'Buborék',
	'bubbleChartDataSlot_xAxisLabel': 'Vízszintes tengely',
	'bubbleChartDataSlot_yAxisLabel': 'Függőleges tengely',
	'bubbleChartDataSlot_sizeLabel': 'Méret e szerint:',
	'bubbleChartDataSlot_colorLabel': 'Szín e szerint:',
	'bubbleChartProp_colorPaletteLabel': 'Színpaletták',
	'bubbleChartProp_hideGridLinesLabel': 'Rácsvonalak elrejtése',
	'bubbleChartProp_hideGridLinesDescription': 'Rácsvonalak elrejtése',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'bubbleChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'bubbleChartProp_hideLegendLabel': 'Jelmagyarázat elrejtése',
	'bubbleChartProp_hideLegendDescription': 'A jelmagyarázat elrejtése.',
	'bubbleChartProp_legendPositionLabel': 'Jelmagyarázat pozíciója',
	'lineChartCaption': 'Vonal',
	'lineChartDataSlot_categoriesLabel': 'Tengelyfelirat',
	'lineChartDataSlot_valuesLabel': 'Érték',
	'lineChartProp_colorPaletteLabel': 'Színpaletták',
	'lineChartProp_lineColorLabel': 'Vonal és szimbólum színe',
	'lineChartProp_symbolShapeLabel': 'Szimbólum alakzat',
	'lineChartProp_hideSymbolsLabel': 'Szimbólumok elrejtése',
	'lineChartProp_hideSymbolsDescription': 'Szimbólumok elrejtése',
	'lineChartProp_hideDataLinesLabel': 'Vonal(ak) elrejtése',
	'lineChartProp_hideDataLinesDescription': 'Vonal(ak) elrejtése',
	'lineChartProp_interpolationLabel': 'Simított vonalak',
	'lineChartProp_interpolationDescription': 'Az adatpontokat összekötő vonalak íveltek.',
	'lineChartProp_hideGridLinesLabel': 'Rácsvonalak elrejtése',
	'lineChartProp_hideGridLinesDescription': 'Rácsvonalak elrejtése',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'lineChartProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'lineChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'lineChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'lineChartProp_suppressZerosLabel': 'Üres elrejtése',
	'lineChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'packedBubbleChart1CatCaption': 'Zárt buborék',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategóriák',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Méret e szerint:',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Színpaletták',
	'packedBubbleChart1CatProp_elementColorLabel': 'Buborék színe',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Címke elrejtése',
	'packedBubbleChart1CatProp_hideValueLabel': 'Érték elrejtése',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Üres elrejtése',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'heatChartCaption': 'Intenzitás',
	'heatChartDataSlot_valuesLabel': 'Intenzitás e szerint:',
	'heatChartDataSlot_xAxisLabel': 'Vízszintes tengely',
	'heatChartDataSlot_yAxisLabel': 'Függőleges tengely',
	'heatChartProp_colorPaletteLabel': 'Színpaletták',
	'heatChartProp_heatScalePaletteLabel': 'Színsorrend',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'heatChartProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'heatChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'heatChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'heatChartProp_suppressZerosLabel': 'Üres elrejtése',
	'heatChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'heatChartProp_hideLegendLabel': 'Jelmagyarázat elrejtése',
	'heatChartProp_hideLegendDescription': 'A jelmagyarázat elrejtése.',
	'heatChartProp_legendPositionLabel': 'Jelmagyarázat pozíciója',
	'pieChartCaption': 'Torta',
	'pieChartDataSlot_categoriesLabel': 'Kategóriák',
	'pieChartDataSlot_valuesLabel': 'Érték',
	'pieChartProp_colorPaletteLabel': 'Színpaletták',
	'pieChartProp_hideRadialValueLabel': 'Érték elrejtése',
	'pieChartProp_pieAsDonutLabel': 'Megjelenítés fánkdiagramként',
	'pieChartProp_pieAsDonutDescription': 'Megjelenítés fánkdiagramként',
	'pieChartProp_suppressZerosLabel': 'Üres elrejtése',
	'pieChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'pieChartProp_hideLegendLabel': 'Jelmagyarázat elrejtése',
	'pieChartProp_hideLegendDescription': 'A jelmagyarázat elrejtése.',
	'pieChartProp_legendPositionLabel': 'Jelmagyarázat pozíciója',
	'map1measureCaption': 'Térkép',
	'map1measureDataSlot_categoriesLabel': 'Régiók',
	'map1measureDataSlot_valuesLabel': 'Régió Intenzitása',
	'map1measureProp_colorPaletteLabel': 'Színpaletták',
	'map1measureProp_heatScalePaletteLabel': 'Színsorrend',
	'map1measureProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'map1measureProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'map1measureProp_suppressZerosLabel': 'Üres elrejtése',
	'map1measureProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'map1measureProp_hideLegendLabel': 'Jelmagyarázat elrejtése',
	'map1measureProp_hideLegendDescription': 'A jelmagyarázat elrejtése.',
	'map1measureProp_legendPositionLabel': 'Jelmagyarázat pozíciója',
	'radialChartCaption': 'Radiális',
	'radialChartDataSlot_categoriesLabel': 'Kategóriák',
	'radialChartDataSlot_valuesLabel': 'Érték',
	'radialChartProp_colorPaletteLabel': 'Színpaletták',
	'radialChartProp_elementColorLabel': 'Radiális sáv színe',
	'radialChartProp_hideRadialTitleLabel': 'Cím elrejtése',
	'radialChartProp_hideRadialValueLabel': 'Érték elrejtése',
	'radialChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'radialChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'radialChartProp_suppressZerosLabel': 'Üres elrejtése',
	'radialChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'pointChart1catCaption': 'Pont',
	'pointChart1catDataSlot_valuesLabel': 'Érték',
	'pointChart1catDataSlot_categoriesLabel': 'Tengelyfelirat',
	'pointChart1catProp_colorPaletteLabel': 'Színpaletták',
	'pointChart1catProp_elementColorLabel': 'Alakzat színe',
	'pointChart1catProp_symbolShapeLabel': 'Szimbólum alakzat',
	'pointChart1catProp_symbolFillLabel': 'Alakzat kitöltése',
	'pointChart1catProp_symbolFillDescription': 'Kitöltési szín megjelenítése a szimbólumokhoz.',
	'pointChart1catProp_hideGridLinesLabel': 'Rácsvonalak elrejtése',
	'pointChart1catProp_hideGridLinesDescription': 'Rácsvonalak elrejtése',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'pointChart1catProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'pointChart1catProp_suppressZerosLabel': 'Üres elrejtése',
	'pointChart1catProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'scatterPlotChartNoCatCaption': 'Pont',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Vízszintes tengely',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Függőleges tengely',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Színpaletták',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Elem színe',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Szimbólum alakzat',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Alakzat kitöltése',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Kitöltési szín megjelenítése a szimbólumokhoz.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Rácsvonalak elrejtése',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Rácsvonalak elrejtése',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'radialBarChartCaption': 'Radiális sáv',
	'radialBarChartDataSlot_categoriesLabel': 'Kategóriák',
	'radialBarChartDataSlot_valuesLabel': 'Érték',
	'radialBarChartProp_colorPaletteLabel': 'Színpaletták',
	'radialBarChartProp_elementColorLabel': 'Radiális sáv színe',
	'radialBarChartProp_hideRadialTitleLabel': 'Cím elrejtése',
	'radialBarChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'radialBarChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'radialBarChartProp_suppressZerosLabel': 'Üres elrejtése',
	'radialBarChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'lineColumnComboChartCaption': 'Vonal és oszlop',
	'lineColumnComboChartDataSlot_categoryLabel': 'Tengelyfelirat',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Vonalérték:',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Oszlopérték',
	'lineColumnComboChartProp_colorPaletteLabel': 'Színpaletták',
	'lineColumnComboChartProp_elementColorLabel': 'Oszlop színe',
	'lineColumnComboChartProp_lineColorLabel': 'Vonal és szimbólum színe',
	'lineColumnComboChartProp_symbolShapeLabel': 'Szimbólum alakzat',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Szimbólumok elrejtése',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Szimbólumok elrejtése',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Vonal(ak) elrejtése',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Vonal(ak) elrejtése',
	'lineColumnComboChartProp_interpolationLabel': 'Simított vonalak',
	'lineColumnComboChartProp_interpolationDescription': 'Az adatpontokat összekötő vonalak íveltek.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Rácsvonalak elrejtése',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Rácsvonalak elrejtése',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Tengelyfeliratok címkéinek elrejtése',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'A tengelyfeliratok elrejtése.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Üres elrejtése',
	'lineColumnComboChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'lineColumnComboChartProp_hideLegendLabel': 'Jelmagyarázat elrejtése',
	'lineColumnComboChartProp_hideLegendDescription': 'A jelmagyarázat elrejtése.',
	'lineColumnComboChartProp_legendPositionLabel': 'Jelmagyarázat pozíciója',
	'summaryCaption': 'Összegzés',
	'areaName': 'Terület',
	'areaDescription': 'Terület',
	'areaDataSlot_colorLabel': 'Szín e szerint:',
	'areaDataSlot_valuesLabel': 'Érték',
	'areaDataSlot_categoriesLabel': 'Tengelyfelirat',
	'bubbleName': 'Buborék',
	'bubbleDescription': 'Buborék',
	'bubbleDataSlot_yAxisLabel': 'Függőleges tengely',
	'bubbleDataSlot_xAxisLabel': 'Vízszintes tengely',
	'bubbleDataSlot_sizeLabel': 'Méret e szerint:',
	'bubbleDataSlot_colorLabel': 'Szín e szerint:',
	'clusterBarName': 'Sáv',
	'clusterBarDescription': 'Sáv',
	'clusterBarDataSlot_colorLabel': 'Szín e szerint:',
	'clusterBarDataSlot_valuesLabel': 'Érték',
	'clusterBarDataSlot_categoriesLabel': 'Tengelyfelirat',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Érték',
	'clusterColumnName': 'Oszlop',
	'clusterColumnDescription': 'Oszlop',
	'clusterColumnDataSlot_colorLabel': 'Szín e szerint:',
	'clusterColumnDataSlot_valuesLabel': 'Érték',
	'clusterColumnDataSlot_categoriesLabel': 'Tengelyfelirat',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Érték',
	'clusterLineName': 'Vonal',
	'clusterLineDescription': 'Vonal',
	'clusterLineDataSlot_colorLabel': 'Szín e szerint:',
	'clusterLineDataSlot_valuesLabel': 'Függőleges tengely',
	'clusterLineDataSlot_categoriesLabel': 'Vízszintes tengely',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Érték',
	'gridName': 'Rács',
	'gridDescription': 'Rács',
	'gridDataSlot_grid_colsLabel': 'Oszlop',
	'heatName': 'Intenzitás',
	'heatDescription': 'Intenzitás',
	'heatDataSlot_yAxisLabel': 'Függőleges tengely',
	'heatDataSlot_xAxisLabel': 'Vízszintes tengely',
	'heatDataSlot_valuesLabel': 'Intenzitás e szerint:',
	'lineColumnComboName': 'Vonal és oszlop',
	'lineColumnComboDescription': 'Vonal és oszlop',
	'lineColumnComboDataSlot_lineValueLabel': 'Vonalérték:',
	'lineColumnComboDataSlot_categoryLabel': 'Tengelyfelirat',
	'lineColumnComboDataSlot_columnValueLabel': 'Oszlopérték',
	'mapName': 'Örökölt térkép',
	'mapDescription': 'Örökölt térkép',
	'mapDataSlot_sizeLabel': 'Pontméret',
	'mapDataSlot_valuesLabel': 'Régió Intenzitása',
	'mapDataSlot_sizeHeatLabel': 'Pont intenzitása',
	'mapDataSlot_categoriesLabel': 'Régiók',
	'packedBubbleName': 'Zárt buborék',
	'packedBubbleDescription': 'Zárt buborék',
	'packedBubbleDataSlot_sizeLabel': 'Méret e szerint:',
	'packedBubbleDataSlot_colorLabel': 'Szín e szerint:',
	'packedBubbleDataSlot_categoriesLabel': 'Kategóriák',
	'pieName': 'Torta',
	'pieDescription': 'Torta',
	'pieDataSlot_valuesLabel': 'Érték',
	'pieDataSlot_categoriesLabel': 'Kategóriák',
	'playerName': 'Adatlejátszó',
	'playerDescription': 'Adatlejátszó',
	'playerDataSlot_categoriesLabel': 'Tengelyfelirat',
	'pointName': 'Pont',
	'pointDescription': 'Pont',
	'pointDataSlot_colorLabel': 'Szín e szerint:',
	'pointDataSlot_valuesLabel': 'Érték',
	'pointDataSlot_categoriesLabel': 'Tengelyfelirat',
	'radialName': 'Radiális',
	'radialDescription': 'Radiális',
	'radialDataSlot_valuesLabel': 'Érték',
	'radialDataSlot_maxSizeLabel': 'Maximális érték',
	'radialDataSlot_categoriesLabel': 'Kategóriák',
	'radialBarName': 'Radiális sáv',
	'radialBarDescription': 'Radiális sáv',
	'radialBarDataSlot_valuesLabel': 'Érték',
	'radialBarDataSlot_categoriesLabel': 'Kategóriák',
	'scatterPlotName': 'Pont',
	'scatterPlotDescription': 'Pont',
	'scatterPlotDataSlot_yAxisLabel': 'Függőleges tengely',
	'scatterPlotDataSlot_xAxisLabel': 'Vízszintes tengely',
	'scatterPlotDataSlot_colorLabel': 'Szín e szerint:',
	'scatterPlotDataSlot_categoriesLabel': 'Pontok',
	'stackedBarName': 'Halmozott sáv',
	'stackedBarDescription': 'Halmozott sáv',
	'stackedBarDataSlot_colorLabel': 'Szín e szerint:',
	'stackedBarDataSlot_valuesLabel': 'Érték',
	'stackedBarDataSlot_categoriesLabel': 'Tengelyfelirat',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Érték',
	'stackedColumnName': 'Halmozott oszlop',
	'stackedColumnDescription': 'Halmozott oszlop',
	'stackedColumnDataSlot_colorLabel': 'Szín e szerint:',
	'stackedColumnDataSlot_valuesLabel': 'Érték',
	'stackedColumnDataSlot_categoriesLabel': 'Tengelyfelirat',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Érték',
	'summaryChartName': 'Összegzés',
	'summaryChartDescription': 'Összegzés',
	'summaryChartDataSlot_valuesLabel': 'Érték',
	'treeMapName': 'Fatérkép',
	'treeMapDescription': 'Fatérkép',
	'treeMapDataSlot_colorLabel': 'Intenzitás e szerint:',
	'treeMapDataSlot_valuesLabel': 'Méret e szerint:',
	'treeMapDataSlot_categoriesLabel': 'Első szint',
	'treeMapDataSlot_level3Label': 'Harmadik szint',
	'treeMapDataSlot_level2Label': 'Második szint',
	'wordCloudName': 'Szófelhő',
	'wordCloudDescription': 'Szófelhő',
	'wordCloudDataSlot_colorLabel': 'Szín e szerint:',
	'wordCloudDataSlot_scaleLabel': 'Méret e szerint:',
	'wordCloudDataSlot_wordLabel': 'Szavak',
	'treeMap1Cat1MeasureChartCaption': 'Fatérkép',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Első szint',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Méret e szerint:',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Színpaletták',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Színpaletták',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Színpaletták',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Színpaletták',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Színpaletták',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Színpaletták',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Üres elrejtése',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Jelmagyarázat elrejtése',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'A jelmagyarázat elrejtése.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Jelmagyarázat pozíciója',
	'wordChart1Cat1MeasureCaption': 'Szófelhő',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Szavak',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Méret e szerint:',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Színpaletták',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Szó színe',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Tengelylépték megtartása',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Mindig jelenítse meg a minimális és a maximális értékeket a tengelyeken.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Üres elrejtése',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'A társított értékkel nem rendelkező kategóriák elrejtése.',
	'missingDataSetData': 'Az adathalmazhoz tartozó adatok nem érhetők el. Frissítse az adathalmazt, vagy lépjen kapcsolatba az adminisztrátorral a forráshoz való hozzáférésért.',
	'hideShowSummaries': 'Összegzések elrejtése/megjelenítése',
	'crosstabName': 'Kereszttábla',
	'value_is_not_available': 'n.a.',
	'swapRowsAndColumns': 'Sorok és oszlopok felcserélése',
	'NoPinsCollected': 'Nincsenek rögzített megjelenítések',
	'pinSearchOld': 'Saját tűk keresése',
	'pinDeletedToast': 'A tű eltávolítása megtörtént',
	'pinAddedToast': 'A tű sikeresen hozzá lett adva a Saját tűkhöz',
	'pinRetrieveError': 'Egy vagy több tű nem kérhető le. Próbálja újra később.',
	'pinErrorTitle': 'Rögzítési hiba',
	'pinRemove': 'Tű eltávolítása',
	'deletePin': 'A tű törlése',
	'dataset_time': 'időpont',
	'dataset_date': 'dátum',
	'dataset_location': 'hely',
	'dataset_number': 'szám',
	'dataset_text': 'szöveg',
	'widgetConditionalFormatLabel': 'Feltételes formátum vezérlőinek váltása',
	'deletePinConfirmationMessage': 'Biztosan törli ezt a tűt? A művelet nem vonható vissza.',
	'deletePinConfirm': 'Törlés megerősítése',
	'pinDeleteError': 'Egy vagy több tű nem törölhető. Próbálja újra később.',
	'metadataPickerTitle': 'Adathalmaz létrehozása',
	'moreTitle': 'Továbbiak',
	'remove_slider_handle': 'Fogó eltávolítása',
	'missingFiltering': 'Hiányzó oszlop:',
	'unSupportedPromptType': 'Az adatkérési forgatókönyv jelenleg nem támogatott.',
	'preAggregateLabel': 'Adatkérési értékek alkalmazása az adatforrásból',
	'postAggregateLabel': 'A jelentésben lévő adatkérési értékek alkalmazása',
	'preAggregateText': 'A tartomány az adatforrásban szereplő értékeket használja, nem a műszerfalon megjelenített értékeket.',
	'tabName_general': 'Általános', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Részletek',
	'tabName_textDetails': 'Szöveg részletei', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Médiatartalom részletei', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Weblap részletei', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Kép részletei', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Megjelenítés',
	'sectionName_canvas': 'Vászon',
	'sectionName_colorsAndThemes': 'Szín és téma',
	'colorsAndThemes_legacyWarning': 'Az aktuális műszerfal egy korábbi kiadás témáját használja. A téma módosítása és a műszerfal mentése véglegesen eltávolítja a hozzáférést a korábbi témapalettákhoz. ',
	'sectionName_details': 'Részletek',
	'sectionName_positionAndStyle': 'Pozíció és stílus',
	'sectionName_appearance': 'Megjelenés', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Speciális',
	'sectionName_layout': 'Elrendezés', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Lapok',
	'sectionName_tabTitle': 'Címke',
	'sectionName_tabBackground': 'Háttér',
	'addDataSourceDialogTitle': 'Adatforrás hozzáadása',
	'addDataSourceDialogButtonLabel': 'Hozzáadás',
	'shapesDoubleChevron': 'Dupla fűrészfog',
	'widgetsPanelTitle': 'Eszközelemek',
	'widgetsPanelBasicsTab': 'Alapok',
	'widgetsPanelImageLibraryTab': 'Képek',
	'widgetsPanelSectionStandard': 'Szabványos',
	'widgetsPanelSectionAdvanced': 'Speciális',
	'widgetsPanelSectionShapes': 'Alakzatok',
	'customWidgetsTitle': 'Egyéni eszközelemek',
	'filterItemCanvasMove': 'Hozzáadás a vászonhoz',
	'filterOverflowMenu_Global': 'Összes lap túlcsordulásmenü',
	'filterOverflowMenu_Tab': 'Aktuális lap túlcsordulásmenü',
	'filterOverflowMenu_Item': 'Szűrő túlcsordulásmenü',
	'filterOverflowMenu_Single': 'Túlcsordulásmenü',
	'filterItemEdit': 'Szűrőértékek szerkesztése',
	'filterDeleteAllItems': 'Összes szűrő törlése',
	'filterClearAllItems': 'Összes szűrő kiürítése',
	'filterClearSelection': 'Szűrő kiürítése',
	'filterPlayerMode': 'Lejátszó megjelenítése',
	'filterStaticMode': 'Lista megjelenítése',
	'filterInvertSelection': 'Szűrő megfordítása',
	'filterIconLabel_Global': 'Minden lap',
	'filterIconLabel_Single': 'Szűrők',
	'filterIconLabel_Tab': 'Ez a lap',
	'filterIconTooltip_Global': 'Minden lap',
	'filterIconTooltip_Tab': 'Ez a lap',
	'filterIconTooltip_Single': 'Szűrők',
	'filterItemDelete': 'Szűrő törlése',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'minden, a következők kivételével: %{from}-%{to}',
	'filterExcept': 'Kivéve: %{values}',
	'filterAll': 'Mind',
	'filterBlank': '(üres)',
	'filterDisableRangeInvert': 'Nem érhető el, ha ez az oszlop szerepel az "Összes lap" szűrőben.',
	'filterDisableHierarchyInvert': 'Nem érhető el, ha ez az oszlop szerepel egy hierarchia szűrőben.',
	'filterSelectedOfTotal': '%{selected} / %{totalMembers}',
	'filter_date_before': '%{to} előtt',
	'filter_date_before_except': 'Nem %{to} előtt',
	'filter_date_after': '%{from} után',
	'filter_date_after_except': 'Nem %{from} után',
	'filter_date_between': '%{from} és %{to} között',
	'filter_date_between_except': 'Nem %{from} és %{to} között',
	'filter_drag_and_drop_all_tabs': 'Húzza ide az adatokat az összes lapon történő szűréshez.',
	'filter_drag_and_drop_current_tab': 'Húzza ide az adatokat az aktuális lapon történő szűréshez.',
	'filter_drag_and_drop_single_dock': 'Húzza ide az adatokat a szűréshez.',
	'errMsgFilterItemGenericTitle': 'A szűrőértékek nem tölthetők be',
	'widgetChromeRotate': 'Elforgatás',
	'toolbarRegionLabel': 'Eszközsáv',
	'toolbarActionDelete': 'Törlés',
	'toolbarActionGroup': 'Csoport',
	'toolbarActionUngroup': 'Csoportbontás',
	'toolbarActionOrderToFront': 'Előreküldés',
	'toolbarActionOrderToBack': 'Hátraküldés',
	'toolbarActionEditTitle': 'Cím szerkesztése',
	'toolbarActionWrapTitle': 'Cím tördelése',
	'toolbarActionPin': 'Gyűjtés',
	'toolbarActionPinOld': 'Rögzítés',
	'toolbarActionAlign': 'Igazítás',
	'alignWidgetLeft': 'Bal',
	'alignWidgetCenter': 'Függőlegesen középen',
	'alignWidgetRight': 'Jobb',
	'alignWidgetTop': 'Felső',
	'alignWidgetMiddle': 'Vízszintesen középen',
	'alignWidgetBottom': 'Alsó',
	'toolbarChangeVisualization': 'Megjelenítés módosítása',
	'multipurposeHeader': 'Válasszon ki egy felületi elem típust',
	'multipurposePlaceholderText': 'A kezdéshez válassza ki az egyik felületi elemet. ',
	'live_label': 'Diagram',
	'filter_label': 'Szűrő',
	'one_named_live': '%{name} diagram',
	'one_named_live_numbered': '%{name} diagram (%{number})',
	'one_unknown_live': 'Diagram',
	'one_unknown_live_numbered': 'Diagram (%{number})',
	'few_live': '%{count} diagramok csoportja',
	'many_live': '%{count} diagramok csoportja',
	'one_custom': 'Egyéni eszközelem',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} szűrő',
	'one_named_filter_numbered': '%{name} szűrő (%{number})',
	'one_unknown_filter': 'Szűrő',
	'one_unknown_filter_numbered': 'Szűrő (%{number})',
	'few_filter': '%{count} szűrők csoportja',
	'many_filter': '%{count} szűrők csoportja',
	'LIVE_bar_has_mapping': '%{values} sávdiagram',
	'LIVE_bar_has_mapping_numbered': '%{values} sávdiagram (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} a(z) %{values} sávdiagram szerint',
	'LIVE_bar_opt_mapping_numbered': '%{categories} a(z) %{values} sávdiagram szerint (%{number})',
	'LIVE_bar_no_mapping': 'Üres sávdiagram',
	'LIVE_bar_no_mapping_numbered': 'Üres sávdiagram (%{number})',
	'LIVE_bar_named': '%{name} sávdiagram',
	'LIVE_bar_named_numbered': '%{name} sávdiagram (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} halmozott sávdiagram',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} halmozott sávdiagram (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} a(z) %{values} halmozott sávdiagram szerint',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} a(z) %{values} halmozott sávdiagram szerint (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Üres halmozott sávdiagram',
	'LIVE_stacked_bar_no_mapping_numbered': 'Üres halmozott sávdiagram (%{number})',
	'LIVE_stacked_bar_named': '%{name} halmozott sávdiagram',
	'LIVE_stacked_bar_named_numbered': '%{name} halmozott sávdiagram (%{number})',
	'LIVE_bubble_has_mapping': '%{categories} a(z) %{x} és %{y} buborékdiagram szerint',
	'LIVE_bubble_has_mapping_numbered': '%{categories} a(z) %{x} és %{y} buborékdiagram szerint (%{number})',
	'LIVE_bubble_no_mapping': 'Üres buborékdiagram',
	'LIVE_bubble_no_mapping_numbered': 'Üres buborékdiagram (%{number})',
	'LIVE_bubble_named': '%{name} buborékdiagram',
	'LIVE_bubble_named_numbered': '%{name} buborékdiagram (%{number})',
	'LIVE_composite_has_mapping': '%{categories} a(z) %{columnValue} és %{lineValue} összetett diagram szerint',
	'LIVE_composite_has_mapping_numbered': '%{categories} a(z) %{columnValue} és %{lineValue} összetett diagram szerint (%{number})',
	'LIVE_composite_no_mapping': 'Üres összetett diagram',
	'LIVE_composite_no_mapping_numbered': 'Üres összetett diagram (%{number})',
	'LIVE_composite_named': '%{name} összetett diagram',
	'LIVE_composite_named_numbered': '%{name} összetett diagram (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} döntési fa',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} döntési fa (%{number})',
	'LIVE_decision_tree_no_mapping': 'Üres döntési fa',
	'LIVE_decision_tree_no_mapping_numbered': 'Üres döntési fa (%{number})',
	'LIVE_decision_tree_named': '%{name} döntési fa',
	'LIVE_decision_tree_named_numbered': '%{name} döntési fa (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} zárt buborékdiagram',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} zárt buborékdiagram (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Üres zárt buborékdiagram',
	'LIVE_packed_bubble_no_mapping_numbered': 'Üres zárt buborékdiagram (%{number})',
	'LIVE_packed_bubble_named': '%{name} zárt buborékdiagram',
	'LIVE_packed_bubble_named_numbered': '%{name} zárt buborékdiagram (%{number})',
	'LIVE_pie_has_mapping': '%{categories} a(z) %{values} kördiagram szerint',
	'LIVE_pie_has_mapping_numbered': '%{categories} a(z) %{values} kördiagram szerint (%{number})',
	'LIVE_pie_no_mapping': 'Üres tortadiagram',
	'LIVE_pie_no_mapping_numbered': 'Üres kördiagram (%{number})',
	'LIVE_pie_named': '%{name} kördiagram',
	'LIVE_pie_named_numbered': '%{name} kördiagram (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} a(z) %{values} fánkdiagram szerint',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} a(z) %{values} fánkdiagram szerint (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Üres fánkdiagram',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Üres fánkdiagram (%{number})',
	'LIVE_pie_as_donut_named': '%{name} fánkdiagram',
	'LIVE_pie_as_donut_named_numbered': '%{name} fánkdiagram (%{number})',
	'LIVE_line_has_mapping': '%{categories} a(z) %{values} vonaldiagram szerint',
	'LIVE_line_has_mapping_numbered': '%{categories} a(z) %{values} vonaldiagram szerint (%{number})',
	'LIVE_line_no_mapping': 'Üres vonaldiagram',
	'LIVE_line_no_mapping_numbered': 'Üres vonaldiagram (%{number})',
	'LIVE_line_named': '%{name} vonaldiagram',
	'LIVE_line_named_numbered': '%{name} vonaldiagram (%{number})',
	'LIVE_area_has_mapping': '%{categories} a(z) %{values} területdiagram szerint',
	'LIVE_area_has_mapping_numbered': '%{categories} a(z) %{values} területdiagram szerint (%{number})',
	'LIVE_area_no_mapping': 'Üres területdiagram',
	'LIVE_area_no_mapping_numbered': 'Üres területdiagram (%{number})',
	'LIVE_area_named': '%{name} területdiagram',
	'LIVE_area_named_numbered': '%{name} területdiagram (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} a(z) %{values} halmozott százalékos területdiagram szerint',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} a(z) %{values} halmozott százalékos területdiagram szerint(%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Üres halmozott százalékos területdiagram',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Üres halmozott százalékos területdiagram (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} halmozott százalékos területdiagram',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} halmozott százalékos területdiagram (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} hőtérkép',
	'LIVE_heatmap_has_mapping_numbered': '%{color} hőtérkép (%{number})',
	'LIVE_heatmap_no_mapping': 'Üres hőtérkép',
	'LIVE_heatmap_no_mapping_numbered': 'Üres hőtérkép (%{number})',
	'LIVE_heatmap_named': '%{name} hőtérkép',
	'LIVE_heatmap_named_numbered': '%{name} hőtérkép (%{number})',
	'LIVE_network_opt_mapping': '%{categories} a(z) %{series} és %{values} háló szerint',
	'LIVE_network_opt_mapping_numbered': '%{categories} a(z) %{series} és %{values} háló szerint (%{number})',
	'LIVE_network_has_mapping': '%{categories} a(z) %{series} háló szerint',
	'LIVE_network_has_mapping_numbered': '%{categories} a(z) %{series} háló szerint (%{number})',
	'LIVE_network_no_mapping': 'Üres hálózat',
	'LIVE_network_no_mapping_numbered': 'Üres hálózat (%{number})',
	'LIVE_network_named': '%{name} hálózat',
	'LIVE_network_named_numbered': '%{name} hálózat (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} a(z) %{values} radiális sávdiagram szerint',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} a(z) %{values} radiális sávdiagram alapján (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} radiális sávdiagram',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} radiális sávdiagram (%{number})',
	'LIVE_radial_bar_no_mapping': 'Üres sugár irányú sávdiagram',
	'LIVE_radial_bar_no_mapping_numbered': 'Üres radiális sávdiagram (%{number})',
	'LIVE_radial_bar_named': '%{name} radiális sávdiagram',
	'LIVE_radial_bar_named_numbered': '%{name} radiális sávdiagram (%{number})',
	'LIVE_spiral_has_mapping': '%{values} spirális diagram',
	'LIVE_spiral_has_mapping_numbered': '%{values} spirális diagram (%{number})',
	'LIVE_spiral_no_mapping': 'Üres spiráldiagram',
	'LIVE_spiral_no_mapping_numbered': 'Üres spirális diagram (%{number})',
	'LIVE_spiral_named': '%{name} spirális diagram',
	'LIVE_spiral_named_numbered': '%{name} spirális diagram (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} a(z) %{size} fa térkép szerint',
	'LIVE_treemap_has_mapping_numbered': '%{categories} a(z) %{size} fa térkép szerint (%{number})',
	'LIVE_treemap_no_mapping': 'Üres fatérkép',
	'LIVE_treemap_no_mapping_numbered': 'Üres fa térkép (%{number})',
	'LIVE_treemap_named': '%{name} fa térkép',
	'LIVE_treemap_named_numbered': '%{name} fa térkép (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} szófelhő',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} szófelhő (%{number})',
	'LIVE_wordcloud_no_mapping': 'Üres szófelhő',
	'LIVE_wordcloud_no_mapping_numbered': 'Üres szófelhő (%{number})',
	'LIVE_wordcloud_named': '%{name} szófelhő',
	'LIVE_wordcloud_named_numbered': '%{name} szófelhő (%{number})',
	'LIVE_data_player_has_mapping': '%{category} adatlejátszó',
	'LIVE_data_player_has_mapping_numbered': '%{category} adatlejátszó (%{number})',
	'LIVE_data_player_no_mapping': 'Üres adatlejátszó',
	'LIVE_data_player_no_mapping_numbered': 'Üres adatlejátszó (%{number})',
	'LIVE_data_player_named': '%{name} adatlejátszó',
	'LIVE_data_player_named_numbered': '%{name} adatlejátszó (%{number})',
	'LIVE_map_has_mapping': '%{locations} térkép',
	'LIVE_map_has_mapping_numbered': '%{locations} térkép (%{number})',
	'LIVE_map_no_mapping': 'Üres térkép',
	'LIVE_map_no_mapping_numbered': 'Üres térkép (%{number})',
	'LIVE_map_named': '%{name} térkép',
	'LIVE_map_named_numbered': '%{name} térkép (%{number})',
	'LIVE_point_has_mapping': '%{categories} a(z) %{values} pontdiagram szerint',
	'LIVE_point_has_mapping_numbered': '%{categories} a(z) %{values} pontdiagram szerint (%{number})',
	'LIVE_point_no_mapping': 'Üres pontdiagram',
	'LIVE_point_no_mapping_numbered': 'Üres pontdiagram (%{number})',
	'LIVE_point_named': '%{name} pontdiagram',
	'LIVE_point_named_numbered': '%{name} pontdiagram (%{number})',
	'LIVE_column_has_mapping': '%{values} oszlopdiagram',
	'LIVE_column_has_mapping_numbered': '%{values} oszlopdiagram (%{number})',
	'LIVE_column_opt_mapping': '%{categories} a(z) %{values} oszlopdiagram szerint',
	'LIVE_column_opt_mapping_numbered': '%{categories} a(z) %{values} oszlopdiagram szerint (%{number})',
	'LIVE_column_no_mapping': 'Üres oszlopdiagram',
	'LIVE_column_no_mapping_numbered': 'Üres oszlopdiagram (%{number})',
	'LIVE_column_named': '%{name} oszlopdiagram',
	'LIVE_column_named_numbered': '%{name} oszlopdiagram (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} halmozott oszlopdiagram',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} halmozott oszlopdiagram (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} a(z) %{values} halmozott oszlopdiagram szerint',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} a(z) %{values} halmozott oszlopdiagram alapján (%{number})',
	'LIVE_stacked_column_no_mapping': 'Üres halmozott oszlopdiagram',
	'LIVE_stacked_column_no_mapping_numbered': 'Üres halmozott oszlopdiagram (%{number})',
	'LIVE_stacked_column_named': '%{name} halmozott oszlopdiagram',
	'LIVE_stacked_column_named_numbered': '%{name} halmozott oszlopdiagram (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories} a(z) %{x} és %{y} szórásdiagram szerint',
	'LIVE_scatter_opt_mapping_numbered': '%{categories} a(z) %{x} és %{y} szórásdiagram szerint (%{number})',
	'LIVE_scatter_has_mapping': '%{x} összehasonlítása a(z) %{y} szórásdiagrammal',
	'LIVE_scatter_has_mapping_numbered': '%{x} összehasonlítása a(z)  %{y} szórásdiagrammal (%{number})',
	'LIVE_scatter_no_mapping': 'Üres pontábrázolás',
	'LIVE_scatter_no_mapping_numbered': 'Üres szórásdiagram (%{number})',
	'LIVE_scatter_named': '%{name} szórásdiagram',
	'LIVE_scatter_named_numbered': '%{name} szórásdiagram (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} vízesés diagram',
	'LIVE_waterfall_has_mapping_numbered': '%{values} vízesés diagram (%{number})',
	'LIVE_waterfall_no_mapping': 'Üres vízesés diagram',
	'LIVE_waterfall_no_mapping_numbered': 'Üres vízesés diagram (%{number})',
	'LIVE_waterfall_named': '%{name} vízesés diagram',
	'LIVE_waterfall_named_numbered': '%{name} vízesés diagram (%{number})',
	'LIVE_empty_visualization_hint_title': 'Állítsa össze a megjelenítést',
	'LIVE_empty_visualization_hint_description': 'Húzza az oszlopokat ide vagy a bal oldali cellákra.',
	'LIVE_slots_required_field_description': '%{asterisk} kötelező mezőt jelöl',
	'LIVE_slots_drag_and_drop_description': 'Húzza az adatokat a fenti cellákra a megjelenítés összeállításához és szűréséhez.',
	'requiredField': 'Kötelező mező',
	'fullScreenEnter': 'Váltás teljes képernyőre',
	'fullScreenClose': 'Kilépés a teljes képernyős módból',
	'noExtraText_multipurpose': 'Többcélú helyőrző',
	'noExtraText_multipurpose_numbered': 'Többcélú helyőrző (%{number})',
	'one_placeholder_vis': 'Megjelenítési helyőrző',
	'one_placeholder_vis_numbered': 'Megjelenítési helyőrző (%{number})',
	'one_placeholder_text': 'Szöveg helyőrző',
	'one_placeholder_text_numbered': 'Szöveg helyőrző (%{number})',
	'few_placeholder_text': '%{count} szöveg helyőrzők csoportja',
	'many_placeholder_text': '%{count} szöveg helyőrzők csoportja',
	'filter_includesAll': 'Összes tartalmazása',
	'timeline_filter_moved_to': 'A(z) %{id} idősor szűrő áthelyezésre került a következő helyre: %{time}',
	'timelineSettingsButton': 'Visszajátszási beállítások',
	'autoPlay': 'Minden jelenet lejátszása',
	'loop': 'Végtelen ciklus',
	'noSceneTransitionLabel': 'Nincs',
	'sceneTransitionPropertyLabel': 'Jelenetátmenet',
	'animatedPathSceneTransitionLabel': 'Animált útvonal',
	'sweepSceneTransitionLabel': 'Pásztázás',
	'propAniAnimation': 'Animáció',
	'propAniTypeEntrance': 'Megjelenés animációja',
	'propAniDirectionIn': 'Megjelenés iránya',
	'propAniTypeExit': 'Kilépés animációja',
	'propAniDirectionOut': 'Kilépés iránya',
	'propAniDirection': 'Irány',
	'timelineAnimationProperties': 'Animáció tulajdonságainak megnyitása',
	'editStoryCoachMarkTitle': 'Történet szerkesztése',
	'editStoryCoachMarkContents': 'Kattintson a Ceruza ikonra a történet szerkesztéséhez.',
	'addDataStoryCoachMarkContents': 'Húzzon át adatokat az adatpanelről a történetre.',
	'expandSceneCoachmarkTitle': 'Idősor megnyitása',
	'expandSceneCoachmarkContents': 'Jelenet animálásához állítsa be az objektum láthatóságát az idő és az időtartam alapján.',
	'overviewCoachmarkTitle': 'Áttekintő jelenetek',
	'overviewCoachmarkContents': 'A története elején és végén az áttekintő jelenetekkel jelenítheti meg az összes jelenet átfogó képét. Egy áttekintő jelenetben kattintással és húzással cserélheti fel a jeleneteket egymással. Megjelenítheti és elrejtheti az áttekintő jeleneteket a történet tulajdonságaiban.',
	'animatedPathCoachmarkTitle': 'Animált útvonal',
	'animatedPathCoachmarkContents': 'Egy objektum animáláshoz az egyik jelenetből a másikba, többszörözzön egy jelenetet egy objektummal. Ezután helyezze át, méretezze át vagy forgassa el a duplikált objektumot az új jeleneten.',
	'tabName_animation': 'Animáció',
	'textWidgetIconPlaceholderText': 'Kattintson ide szöveg hozzáadásához',
	'buildVisHeader': 'Megjelenítés létrehozása',
	'visIconPlaceholderText': 'Húzza ide a mezőket a megjelenítés összeállításához',
	'launchNewExplore': 'Új böngészés',
	'addTo': 'Hozzáadás ehhez:',
	'addToExisting': 'Hozzáadás létezőhöz...',
	'exploreData': 'Böngészés',
	'explore_remove_widget_styles': 'Az egyéni megjelenítési tulajdonságok, például a színbeállítások, nem kerülnek tárolásra a böngészésben.',
	'editNotebook': 'Felületi elem szerkesztése',
	'thumbnails_error_fetching': 'Hiba a miniatűrök lehívásakor',
	'copy': '{count} eszköz került másolásra',
	'specConvertErr': 'Hiba történt a műszerfal-specifikáció beillesztésekor vagy átalakításakor',
	'specCopyErr': 'Hiba történt a műszerfal-specifikáció másolásakor',
	'pasteNotSupportedErr': '%{name} forrásból a beillesztés nem támogatott.',
	'reportParam': 'jelentés',
	'filterWidgetCopyWarn': 'A szűrő megjelenítése nem került másolásra, mert jelenleg nem támogatottak a szűrők.',
	'upgradingDashboard': '"%{name}" frissítése a következőre: %{version}...',
	'upgradeComplete': 'A frissítés kész',
	'individualTabProperties': 'Egyéni lap tulajdonságai',
	'propMasterTabStylesLabel': 'Elsődleges lap stílusa',
	'propTabPosition': 'Lap pozíciója',
	'propTabTitle': 'Cím',
	'propTabBackgroundColor': 'Kitöltés színe',
	'propTabTextColor': 'Cím színe',
	'propTabSelectedBarColor': 'Kijelölt sáv színe',
	'propTabRestoreDefaults': 'Alapértékek visszaállítása',
	'propIndividualTabStylesLabel': 'Egyéni lap stílusa',
	'propIndividualTabStylesAriaLabel': 'Egyéni lapstílus tulajdonságainak megnyitása',
	'propTabIconPosition': 'Ikon pozíciója',
	'propLeftTitle': 'Cím bal oldala',
	'propRightTitle': 'A címtől jobbra',
	'propTopTitle': 'A cím felett',
	'propBottomTitle': 'A cím alatt',
	'propTabIconLabel': 'Vizuális elem',
	'propTabIcon': 'Ikon',
	'propTabIconColor': 'Ikon színe',
	'no_icon': 'Üres',
	'announcement': 'Bejelentések',
	'api': 'Api',
	'archive': 'Archiválás',
	'asset': 'Eszköz',
	'attachment': 'Melléklet',
	'audio': 'Hanganyag',
	'bee': 'Bee',
	'blog': 'Blog',
	'bookmark': 'Könyvjelző',
	'calendar': 'Naptár',
	'camera': 'Kamera',
	'capability': 'Jogosultság',
	'catalog': 'Katalógus',
	'chat_message': 'Csevegés üzenet',
	'checkout_cart': 'Kosár kiiktatása',
	'client': 'Kliens',
	'clock': 'Óra',
	'cloud': 'Felhő',
	'code': 'Kód',
	'data_quality': 'Adatok minősége',
	'folder': 'Mappák',
	'forum': 'Fórum',
	'glasses': 'Szemüveg',
	'group': 'Csoport',
	'hat': 'Kalap',
	'headphone': 'Fejhallgató',
	'hills': 'Hills',
	'home': 'Kezdőlap',
	'idea': 'Ötlet',
	'image': 'Kép',
	'inventory': 'Leltár',
	'like': 'Kedvelés',
	'link': 'Hivatkozás',
	'location': 'Hely',
	'manage': 'Kezelés',
	'pen': 'Toll',
	'mobile_phone': 'Mobiltelefon',
	'music': 'Zene',
	'notifications': 'Értesítések',
	'paint': 'Paint',
	'payment': 'Fizetés',
	'password_key': 'Jelszókulcs',
	'people': 'Személyek',
	'person': 'Személy',
	'phone': 'Telefonszám',
	'pin': 'Rögzítés',
	'print': 'Nyomtatás',
	'recording': 'Rögzítés',
	'repository': 'Tároló',
	'role': 'Szerep',
	'search': 'Keresés',
	'properties': 'Tulajdonságok',
	'speaker': 'Hangszóró',
	'star': 'Csillag',
	'tag': 'Címke',
	'thumbs_up': 'Tetszik',
	'thumbs_down': 'Nem tetszik',
	'tools': 'Eszközök',
	'traffic': 'Forgalom',
	'trash': 'Szemétgyűjtő',
	'twitter': 'Twitter',
	'unknown': 'Ismeretlen',
	'user': 'Felhasználó',
	'venn_diagram': 'Venn diagram',
	'video': 'Videó',
	'view': 'Nézet',
	'warning': 'Figyelmeztetés',
	'watch': 'Figyelés',
	'watson': 'Watson',
	'wikis': 'Wiki oldalak',
	'workspace': 'Munkaterület',
	'world': 'Világ',
	'OnLoadFilterModifierDatasourceMismatch': 'A szűrők nem kerülnek alkalmazásra a célon, mert a műszerfalak különböző forrásokat használnak.',
	'OnLoadFilterModifierColumnMismatch': 'Néhány szűrő nem került alkalmazásra, mert a megfelelő oszlop(ok) nem található(k).',
	'eventGroupButtonLabel': 'Eszközelem-kapcsolódások megtekintése',
	'dockToolbar': 'Eszköztár rögzítése',
	'undockToolbar': 'Eszköztár lekapcsolása',
	'propShowTitle': 'Cím megjelenítése'
});
